import Stack from '@mui/material/Stack';
import { useForm } from 'react-hook-form';

import { SocialLinksEditor } from '@/components/form/SocialLinksEditor';
import type { SocialLinkRow } from '@/lib/socialLinks';

import { State } from '../State';

interface SampleLinks {
  social_links: SocialLinkRow[];
}

export function SocialLinksEditorExamples() {
  const {
    control,
    formState: { errors },
  } = useForm<SampleLinks>({
    defaultValues: {
      social_links: [
        { platform: 'twitter', custom: '', url: 'https://x.com/sample' },
        { platform: 'mastodon', custom: '', url: 'https://mastodon.social/@sample' },
      ],
    },
  });

  return (
    <State
      title="Rows that can be added and removed"
      note="Focus follows an added row; every control carries its row's number."
    >
      <Stack spacing={2} sx={{ maxWidth: 560 }}>
        <SocialLinksEditor name="social_links" control={control} errors={errors} />
      </Stack>
    </State>
  );
}
